import { Component, Inject, Input, LOCALE_ID, OnInit, ViewEncapsulation } from '@angular/core';
import { Product, ProductDescriptionSection } from '@scalefast/core';
import { AppAccordionComponent } from '../../../shared/components/accordion/accordion.component';

@Component({
  selector: 'app-product-description-accordion',
  styleUrls: ['./product-description-accordion.component.scss'],
  template: '<app-accordion class="product-description__accordion" [sections]="sections" [oppenedDefault]="oppenedDefault" />',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [AppAccordionComponent],
})
export class AppProductDescriptionAccordionComponent implements OnInit {
  descriptionTitle: string = '';
  sections: Array<ProductDescriptionSection> = [];

  @Input() dynamicTitles: any;
  @Input() oppenedDefault: boolean = true;
  @Input() product: Product | undefined;

  constructor(@Inject(LOCALE_ID) private locale: string) {}

  ngOnInit(): void {
    if (this.product) this.setSections(this.product);
  }

  setSections(product: Product) {
    if (!product.descriptions || product.descriptions.length === 0) {
      return;
    }

    const productDescription = product.descriptions.find((d) => d.lang === this.locale) || product.descriptions[0];

    if (!productDescription.long || !productDescription.sections || productDescription.sections.length === 0) {
      return;
    }

    this.sections = productDescription.sections.map((section: ProductDescriptionSection) => ({
      ...section,
      title: section.i18nTitleTag ? this.dynamicTitles[section.i18nTitleTag] : section.title,
    }));
  }
}
